import React from 'react';
import { useDispatch } from 'react-redux'

import Aux from '../../hoc/Aux';
import { useForm } from 'react-hook-form'
import * as actions from '../../store/actions/index';
import Navigation from './Navigation';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const changePassword = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, setError, errors, handleSubmit } = useForm();
  const alert = useAlert();
  const ht = useCustomHtmlTranslation();
  const ct = useCustomTranslation();

  const onSubmit = data => {
    dispatch( actions.savePassword(data) ).then( (res) => {
      if (res && res.errors){
        errorHandling(res.errors);
        alert.show( ct('change_password.error'), {type: "error"})
      } else {
        alert.show( ct('change_password.success'), {type: "success"});
      }
    });
  };

  const errorHandling = (e) => {

    if ( Array.isArray(e['password']) ) {
      setError("password", {
              type: "manual",
              message: ct('form.changePassword.errors.password.' + e['password'][0]['error'] )
            });
    }
    if ( Array.isArray(e['old_password']) ) {
      setError("oldPassword", {
              type: "manual",
              message: ct('form.changePassword.errors.oldPassword.' + e['old_password'][0]['error'] )
            });
    }
    if ( Array.isArray(e['password_confirmation']) ) {
      setError("passwordConfirmation", {
              type: "manual",
              message: ct('form.changePassword.errors.passwordConfirmation.' + e['password_confirmation'][0]['error'] )
            });
    }

  }

  const intialValues = {
    oldPassword: '',
    password: '',
    passwordConfirmation: '',
  };

  const fieldClassName = (error) => {
    return (error)? "form-control is-invalid" : "form-control"
  }

  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName])?
       <div className="invalid-feedback">
          {t('form.changePassword.errors.' + fieldName + '.required')}
        </div> : null
  }

  return (
    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
    				<div className="col-lg-10 col-xl-9">
    					<div className="page-header">
    						<h1 className="pb-2">{ ct('change_password.title') }</h1>
                <span className="lead">
                  { ht('account.edit_password') }
                </span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
    				<div className="col-lg-3 mb-3">
              <Navigation activeItem="change_password" />
    				</div>

    				<div className="col-lg-7 col-xl-6">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>{ ct('change_password.subtitle') }</h4>
    									<form onSubmit={handleSubmit(onSubmit)}>

                        <div className="form-group row align-items-center">
                          <label className="col-3">{ ct('change_password.form.current_password') }</label>
                          <div className="col">
                            <input
                              type="password"
                              className={fieldClassName(errors.oldPassword)}
                              name="oldPassword"
                              defaultValue={intialValues.oldPassword}
                              ref={register({ required: true})} />
                               { (errors.oldPassword)?
                                   <div className="invalid-feedback">
                                      {errors.oldPassword.message}
                                    </div> : null
                                }
                                { errorMessage(errors, 'oldPassword') }
                          </div>
                        </div>

                        <div className="form-group row align-items-center">
                          <label className="col-3">{ ct('change_password.form.new_password') }</label>
                          <div className="col">
                            <input
                              type="password"
                              className={fieldClassName(errors.password)}
                              name="password"
                              defaultValue={intialValues.password}
                              ref={register()} />
                               { (errors.password)?
                                   <div className="invalid-feedback">
                                      {errors.password.message}
                                    </div> : null
                                }
                          </div>
                        </div>

                        <div className="form-group row align-items-center">
                          <label className="col-3">{ ct('change_password.form.repeat_new_password') }</label>
                          <div className="col">
                            <input
                              type="password"
                              className={fieldClassName(errors.passwordConfirmation)}
                              name="passwordConfirmation"
                              defaultValue={intialValues.passwordConfirmation}
                              ref={register()} />
                            { (errors.passwordConfirmation)?
                                   <div className="invalid-feedback">
                                      {errors.passwordConfirmation.message}
                                    </div> : null
                                }
                          </div>
                        </div>

    										<div className="row justify-content-end">
    											<button type="submit" className="btn btn-primary btn-project">{ ct('change_password.form.button.save') }</button>
    										</div>
    									</form>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  );


};

export default changePassword;



// WEBPACK FOOTER //
// ./src/components/User/ChangePassword.js